module.exports = __webpack_public_path__ + "static/media/slide-2.e5a99e55.jpg";